export default __webpack_public_path__ + "static/media/main-logo.848caa59.svg";